export default {
    name: 'faq',
    data() {
        return {
            items: []
        }
    },
    methods: {
        
    },
    mounted() {
        this.$store.dispatch('pub/getFaqItems')
            .then(res => {
                this.items = res.data.data
            })
    }
}